module.exports = __webpack_public_path__ + "static/media/green.0e970876.png";